import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryWithAuthLogout } from "./index";

export const profileApi = createApi({
    reducerPath: "profileApi",
    baseQuery: baseQueryWithAuthLogout,
    tagTypes: ["Profile"],
    endpoints: (builder) => ({
        getProfileData: builder.query({
            query: () => `/auth/me`,
            providesTags: ["Profile"],
        }),

        sendProfileOtp: builder.mutation({
            query: (payload) => ({
                url: "/auth/send-profile-otp",
                method: "PUT",
                body: payload,
            }),
            invalidatesTags: ["Profile"],
        }),
        verifyProfileOtp: builder.mutation({
            query: (payload) => ({
                url: "/auth/verify-profile-otp",
                method: "PUT",
                body: payload,
            }),
            invalidatesTags: ["Profile"],
        }),
        uploadProfileImage: builder.mutation({
            query: (payload) => ({
                url: "/file/single",
                method: "POST",
                body: payload,
            }),
            invalidatesTags: ["Profile"],
        }),
    }),
});

export const {
    useSendProfileOtpMutation,
    useVerifyProfileOtpMutation,
    useGetProfileDataQuery,
    useUploadProfileImageMutation
} = profileApi;
